import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404 Error! Your Requested Page is Not Found</h1>
        </div>
    );
};

export default NotFound;